/* ==========================================================================
   NEURODAZZLED — FLAGSHIP · nd-flagship.js (no dependencies)
   Header state · gentle reveal · room shelf hint · product form (real
   variants, AJAX add to bag) · mobile buy bar. The page works without it.
   Menu dialog, Noise on/off, cart count and review panel live in nd-base.js.
   ========================================================================== */
(function () {
  var html = document.documentElement;
  var S = (window.nd && window.nd.strings) || {};
  var calm = function () { return html.getAttribute('data-noise') === 'off' || html.getAttribute('data-motion') === 'reduce'; };

  /* Header: transparent over the hero, solid after it */
  function initHeader() {
    var hdr = document.querySelector('[data-f-hdr]');
    if (!hdr) return;
    var hero = document.querySelector('[data-f-hero]');
    if (hdr._fHeaderCleanup) hdr._fHeaderCleanup();
    var limit = 0, frame = 0;
    var set = function () { hdr.classList.toggle('is-solid', !hero || window.scrollY > limit); };
    var measure = function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        limit = hero ? hero.getBoundingClientRect().bottom + window.scrollY - hdr.offsetHeight - 10 : 0;
        frame = 0;
        set();
      });
    };
    window.addEventListener('scroll', set, { passive: true });
    window.addEventListener('resize', measure);
    var ro = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
    if (ro) { ro.observe(hdr); if (hero) ro.observe(hero); }
    hdr._fHeaderCleanup = function () {
      window.removeEventListener('scroll', set);
      window.removeEventListener('resize', measure);
      if (ro) ro.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
    measure();
  }

  /* Reveal: only when motion is allowed and Noise is on. Never leaves content hidden. */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-f-rv]:not(.is-in),[data-f-rvi]:not(.is-in)');
    if (calm() || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      html.classList.remove('f-motion');
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    html.classList.add('f-motion');
    io = io || new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (el) {
      io.observe(el);
    });
  }
  function revealAll() { html.classList.remove('f-motion'); document.querySelectorAll('[data-f-rv],[data-f-rvi]').forEach(function (el) { el.classList.add('is-in'); }); }
  document.addEventListener('nd:noise', function (e) { if (e.detail && e.detail.state === 'off') revealAll(); });
  document.addEventListener('nd:motion', function (e) { if (e.detail && e.detail.state === 'reduce') revealAll(); });
  setTimeout(function () { if (!io) revealAll(); }, 2500);

  function initShelf(root) {
    (root || document).querySelectorAll('[data-f-shelf]').forEach(function (shelf) {
      if (shelf._fShelfCleanup) shelf._fShelfCleanup();
      var parent = shelf.parentNode;
      var nav = parent.querySelector('[data-f-shelf-nav]');
      var action = parent.querySelector('[data-f-shelf-action]');
      var hint = parent.querySelector('[data-f-shelf-hint]');
      var dots = parent.querySelectorAll('[data-f-shelf-hint] span');
      var cards = Array.from(shelf.children);
      var frame = 0;
      var max = function () { return Math.max(0, shelf.scrollWidth - shelf.clientWidth); };
      var atEnd = function () { return shelf.scrollLeft >= max() - 2; };
      function update() {
        frame = 0;
        var overflow = max() > 2;
        if (nav) nav.hidden = !overflow;
        if (hint) hint.hidden = !overflow;
        if (action) {
          action.textContent = action.getAttribute(atEnd() ? 'data-back' : 'data-next');
          action.setAttribute('data-position', atEnd() ? 'end' : 'forward');
        }
        var index = Math.round(shelf.scrollLeft / (max() || 1) * (dots.length - 1));
        dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === index); });
        if (shelf.closest('#rooms')) {
          if (window.matchMedia('(max-width:760px)').matches && cards.length) {
            var active = cards[Math.max(0, Math.min(cards.length - 1, index))];
            var shelfStyle = window.getComputedStyle(shelf);
            var height = Math.ceil(active.getBoundingClientRect().height + (parseFloat(shelfStyle.paddingTop) || 0) + (parseFloat(shelfStyle.paddingBottom) || 0));
            var value = height + 'px';
            if (height > 0 && shelf.style.getPropertyValue('--f-shelf-height') !== value) shelf.style.setProperty('--f-shelf-height', value);
          } else shelf.style.removeProperty('--f-shelf-height');
        }
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(update); }
      function move(left) {
        var reduce = calm() || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        shelf.scrollTo({left: Math.max(0, Math.min(max(), left)), behavior: reduce ? 'instant' : 'smooth'});
      }
      function step(direction) {
        var edge = shelf.getBoundingClientRect().left;
        var positions = cards.map(function (card) { return card.getBoundingClientRect().left - edge + shelf.scrollLeft; });
        var target = direction > 0 ? positions.find(function (p) { return p > shelf.scrollLeft + 2; }) : positions.reverse().find(function (p) { return p < shelf.scrollLeft - 2; });
        move(target == null ? (direction > 0 ? max() : 0) : target);
      }
      function activate() { if (atEnd()) move(0); else step(1); }
      function keyboard(event) {
        if (event.target !== shelf || max() <= 2) return;
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        if (event.key === 'Home') move(0);
        else if (event.key === 'End') move(max());
        else step(event.key === 'ArrowRight' ? 1 : -1);
      }
      shelf.addEventListener('scroll', schedule, {passive: true});
      shelf.addEventListener('keydown', keyboard);
      if (action) action.addEventListener('click', activate);
      window.addEventListener('resize', schedule);
      var resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
      if (resize) { resize.observe(shelf); cards.forEach(function (card) { resize.observe(card); }); }
      shelf._fShelfCleanup = function () {
        shelf.removeEventListener('scroll', schedule);
        shelf.removeEventListener('keydown', keyboard);
        if (action) action.removeEventListener('click', activate);
        window.removeEventListener('resize', schedule);
        if (resize) resize.disconnect();
        shelf.style.removeProperty('--f-shelf-height');
        if (frame) cancelAnimationFrame(frame);
      };
      update();
    });
  }

  /* Product form: real variants, real cart */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-f-product]').forEach(function (el) {
      if (el._f) return; el._f = true;
      var form = el.querySelector('form');
      var idInput = el.querySelector('[name="id"]');
      var variants = JSON.parse((el.querySelector('[data-f-variants]') || {}).textContent || '[]');
      var sets = [].slice.call(el.querySelectorAll('[data-f-option]'));
      var priceEl = el.querySelector('[data-f-price]');
      var btn = el.querySelector('[data-f-add]');
      var status = el.querySelector('[data-f-status]');
      var section = el.closest('section');
      var img = section.querySelector('.f-prod-img, .f-pdp__main img');
      var bar = document.querySelector('[data-f-buybar]');
      var barLab = bar && bar.querySelector('[data-f-buybar-sel]');
      var barBtn = bar && bar.querySelector('[data-f-buybar-add]');
      var labelAdd = btn ? (btn.getAttribute('data-label-add') || btn.textContent) : (S.addToBag || 'Add to bag');
      var labelOut = btn && btn.getAttribute('data-label-out');
      var sel = function () { return sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); };
      var current = function () { if (!sets.length) { return variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0]; } var s = sel(); return variants.filter(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); })[0]; };
      function update(fromUser) {
        var s = sel();
        sets.forEach(function (fs, idx) {
          var lv = fs.querySelector('[data-f-option-value]'); if (lv) lv.textContent = s[idx] || '';
          fs.querySelectorAll('.f-pill').forEach(function (p) {
            var val = p.querySelector('input').value;
            var ok = variants.some(function (x) { return x.available && x.options[idx] === val && x.options.every(function (o, i) { return i === idx || o === s[i]; }); });
            p.classList.toggle('is-unavailable', !ok);
          });
        });
        var v = current();
        if (barLab) barLab.textContent = s.filter(Boolean).join(' · ');
        if (!v) { setBtn(false, S.unavailable || 'Unavailable'); return; }
        idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = (v.price === 0 ? (S.free || 'Free') : v.price_formatted) + (v.compare_at_price > v.price ? ' <s>' + v.compare_formatted + '</s>' : '');
        setBtn(v.available, v.available ? labelAdd : (labelOut || S.soldOut || 'Sold out'));
        if (fromUser) {
          if (section.classList.contains('f-pdp')) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
          if (img && v.image) {
            img.removeAttribute('srcset');
            img.src = v.image;
            if (v.image_alt) img.alt = v.image_alt;
            var imageLink = img.closest('[data-f-gallery-open]');
            if (imageLink) {
              var largeImage = new URL(v.image, window.location.origin);
              largeImage.searchParams.set('width', '2400');
              imageLink.href = largeImage.toString();
            }
          }
        }
      }
      function setBtn(on, label) {
        if (!btn) return;
        btn.disabled = !on; btn.textContent = label;
        if (barBtn) { barBtn.disabled = !on; barBtn.textContent = label; }
      }
      sets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
      if (form) form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = S.adding || 'Adding…';
        status.textContent = '';
        fetch((window.nd && window.nd.routes && window.nd.routes.cartAdd) || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || S.addError); return d; }); })
          .then(function (d) { status.innerHTML = S.added || 'Added to your bag.'; document.dispatchEvent(new CustomEvent('nd:cart-updated', { detail: d })); })
          .catch(function (err) { status.innerHTML = '<span class="f-msg--err">' + ((err && err.message) || S.addError || 'Something went wrong.') + '</span>'; })
          .then(function () { btn.removeAttribute('aria-busy'); update(false); });
      });
      if (barBtn) barBtn.addEventListener('click', function () {
        if (btn.disabled) { btn.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
      update(false);
      /* Mobile buy bar: visible while the product section is on screen */
      var sec = el.closest('[data-f-prod-sec]');
      if (bar && sec && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            bar.classList.toggle('is-on', e.isIntersecting);
            bar.setAttribute('aria-hidden', e.isIntersecting ? 'false' : 'true');
            bar.toggleAttribute('inert', !e.isIntersecting);
            document.body.classList.toggle('f-buy-on', e.isIntersecting);
          });
        }, { threshold: 0.15 }).observe(sec);
      }
    });
  }

  function initAll(root) { initReveal(root); initShelf(root); initProduct(root); }
  initHeader();
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initHeader(); initAll(e.target); });
})();
/* V2 review only: compare display faces (session only, never saved to the theme) */
(function () {
  var html = document.documentElement, KEY = 'nd-review-display';
  var btns = document.querySelectorAll('[data-nd-review-display]');
  if (!btns.length) return;
  var set = function (v) {
    html.setAttribute('data-display', v);
    try { sessionStorage.setItem(KEY, v); } catch (e) {}
    btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-nd-review-display') === v)); });
  };
  var cur = html.getAttribute('data-display') || 'bodoni';
  btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-nd-review-display')); }); });
  set(cur);
})();
